import { useEffect } from "react";
import useApi from "./useApi";

/**
 * useFetch Hook
 * Wrapper around useApi for automatic execution on mount.
 * 
 * @param {Function} apiFunc - The async function to execute.
 * @param {Array} dependencies - Dependency array for useEffect.
 * @returns {Object} { data, loading, error, refetch: execute }
 */
const useFetch = (apiFunc, dependencies = []) => {
  const { data, isLoading, error, execute } = useApi(apiFunc, true);

  useEffect(() => {
    execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);

  return { data, isLoading, error, refetch: execute };
};

export default useFetch;
